import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './FormError.scss'

const FormError = ({ error }) =>
	<span styleName="form-error">
		{error}
	</span>

FormError.propTypes = {
	error: React.PropTypes.string
}

export default CSSModules(FormError, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Form/FormError.js